import React from 'react';
import styled from 'styled-components';
import Regulations from '../components/Regulations';
const GridWrapper = styled.div`
  margin-top: 1em;
  margin-left: 3em;
  margin-right: 3em;
`; export const Manual = () => (
  <GridWrapper>
    <Regulations displayOnly></Regulations>
  </GridWrapper>
)